<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>代理商申请记录</span>
        <el-select v-model="filterStatus" placeholder="全部状态" clearable style="width: 140px" @change="handleSearch">
          <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
      </div>

      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="编号" width="70" />
        <el-table-column label="申请人" min-width="120">
          <template slot-scope="{ row }">{{ row.applicantName || `用户${row.userId}` }}</template>
        </el-table-column>
        <el-table-column prop="agentName" label="代理商名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="promoCode" label="推广码" width="120" />
        <el-table-column label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="statusTagType(row.status)">{{ labelOf(AGENT_STATUS, row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" min-width="120">
          <template slot-scope="{ row }">{{ formatUserDate(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="{ row }">
            <template v-if="row.status === 0">
              <el-button type="text" size="small" @click="handleAudit(row, 1)">通过</el-button>
              <el-button type="text" size="small" class="danger" @click="handleAudit(row, 2)">驳回</el-button>
            </template>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getAgents, updateAgent } from '@/api/admin'
import { AGENT_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'
import { formatUserDate } from '@/utils/userFormat'
import listPage from '@/mixins/listPage'

export default {
  name: 'AgentsApplications',
  mixins: [listPage],
  data() {
    return {
      AGENT_STATUS,
      filterStatus: 0
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(AGENT_STATUS).filter(opt => opt.value !== 3)
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    labelOf,
    formatUserDate,
    statusTagType(status) {
      if (status === 1) return 'success'
      if (status === 2) return 'danger'
      return 'warning'
    },
    fetchList(params) {
      return getAgents({
        ...params,
        status: this.filterStatus != null ? this.filterStatus : undefined
      })
    },
    handleAudit(row, status) {
      const action = status === 1 ? '通过' : '驳回'
      this.$confirm(`确定${action}「${row.agentName}」的代理申请？`, '审核确认', {
        type: status === 1 ? 'success' : 'warning'
      }).then(async () => {
        await updateAgent(row.id, {
          agentName: row.agentName,
          promoCode: row.promoCode,
          status
        })
        this.$message.success(`已${action}`)
        this.loadList()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
.danger {
  color: #f56c6c;
}
.muted {
  color: #c0c4cc;
}
</style>
